import React from 'react'
import ContainerLayout from '../../../components/container-layout/ContainerLayout'
import NavigateListCustom from '../../../components/navigation/NavigationListCustom'
import { routeName } from '../../../routes/routeName'
import StateComponents from '../../../components/state-component/StateComponents'
import ManageStateComplaintSubmitList from './manageStateComplaintSubmitList'
import TableCustom from '../../../components/table/tableCustom'
import { useNavigate } from 'react-router-dom'
import { debouncedApiCall } from '../../../utils/app.utils'
import { COMPLAINTS_STATUS_DATA } from './enum/complaint.enum'
import { useTranslation } from 'react-i18next'

type Props = {}

const ComplaintSubmitList: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        date_range,
        handleChangeDateRange,
        id_complaints_type,
        set_id_complaints_type,
        set_search_complaint_type,
        complaint_type_data,
        set_status,
        status
    } = ManageStateComplaintSubmitList()
    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("COMPLAINTS_SUBMIT_COMPLAINT")}
                hidden_sub_title
                navigateContent={
                    <NavigateListCustom
                        navigateData={[
                            {
                                key: "complaintSubmit",
                                name: t("COMPLAINTS_COMPLAINT_SYSTEM"),
                                disabled_match: true,
                                pathName: routeName.students.complaintSubmit,
                            },
                            {
                                key: "complaintSubmit",
                                name: t("COMPLAINTS_SUBMIT_COMPLAINT"),
                                pathName: routeName.students.complaintSubmit
                            },
                        ]}
                    />
                }
                content={
                    <div className='w-full'>
                        <StateComponents
                            otherProps={{ spacing: 2 }}
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "AUTO-COMPLETE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3.3
                                    },
                                    fieldProps: {
                                        getOptionLabel: (op) => op?.complaints_type_name || "",
                                        labelId: "id_complaints_type",
                                        onChange: (_: unknown, val: any) => set_id_complaints_type(val),
                                        onInputChange: (_: any, val: string) => debouncedApiCall({ searchItem: val, setItem: set_search_complaint_type }),
                                        placeholder: t("COMPLAINTS_ALL_CATEGORIES"),
                                        options: complaint_type_data || [],
                                        value: id_complaints_type
                                    }
                                },
                                {
                                    seq: 2,
                                    type: "DATE_RANGE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3.3
                                    },
                                    fieldProps: {
                                        onchange: handleChangeDateRange,
                                        allowClear: true,
                                        onClear: () => handleChangeDateRange([]),
                                        placeholder: t("COMPLAINTS_DATE_RANGE"),
                                        value: date_range

                                    }
                                },
                                {
                                    seq: 3,
                                    type: "AUTO-COMPLETE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3.3
                                    },
                                    fieldProps: {
                                        getOptionLabel: (op) => t(op.label),
                                        labelId: "COMPLAINTS_STATUS_DATA",
                                        onChange: (_, val) => set_status(val?.value),
                                        placeholder: t("COMPLAINTS_ALL_STATUSES"),
                                        options: COMPLAINTS_STATUS_DATA || [],
                                        value: COMPLAINTS_STATUS_DATA.find((x) => x.value === status) || null
                                    }
                                },
                                {
                                    seq: 4,
                                    type: "BUTTON",
                                    gridProps: {
                                        xs: 12,
                                        md: 2.1
                                    },
                                    fieldProps: {
                                        buttonData: [
                                            {
                                                key: "SEND",
                                                label: t("COMPLAINTS_SUBMIT_COMPLAINT"),
                                                seq: 1,
                                                type: "SEND",
                                                fullWidth: true,
                                                buttonProps: {
                                                    onClick: () => navigate(routeName.students.complaintSubmitCreate)
                                                }
                                            }
                                        ]
                                    }
                                },
                            ]}
                        />

                        <div className='mt-10'>
                            <section className='w-full mt-10'>
                                <TableCustom
                                    tableMinWidth={1440}
                                    tableFixedWidth
                                    customScroll
                                    page={page}
                                    pageLimit={pageLimit}
                                    sortBy={sortBy}
                                    sortType={sortType}
                                    headCells={headCells}
                                    rowCount={totalItems}
                                    rowsData={data?.map((data: any, i: any) => {
                                        return renderData(data, i)
                                    })}
                                    onSort={handleRequestSort}
                                    setPageLimit={(value: number) => setPageLimit(value)}
                                    setPage={(value: number) => setPage(value)}
                                />
                            </section>
                        </div>
                    </div>
                }
            />
        </div>
    )
}

export default ComplaintSubmitList